module.exports = __webpack_public_path__ + "img/portone.ac57ff02.png";